<app-loader-spinner></app-loader-spinner>
@if (loaded) {
<router-outlet></router-outlet>
}
<app-floating-download-indicator></app-floating-download-indicator>